<template>
  <div class="col-lg-3 col-md-4 d-none d-md-block"
  id="categorySectionContainer"
   >
  <affix
    relative-element-selector="#menu-section" 
    :offset="{ top: 170, bottom: 20, padding: 0 }"
    :style="{'width': newWidth}"
  >
    <h6 class="affix-title">{{ $t("text.categories") }}</h6>
    <ul class="container-scroller1 list-group" id="list-tab" role="tablist">
      <li :style="[activeCategory == category.id ? myTheme.categories.active : '']"
        v-if="selectedLocation.specials && selectedLocation.specials.length"
        class="list-group-item category-item"
      >
        <n-button
          type="primary" 
          link
          v-scroll-to="{ el: '#special', offset: -180 }"
          class="list-group-item list-group-item-action"
          style="color:#000000"
          data-toggle="list"
          >{{ $t('text.special') }}</n-button
        >
      </li>
      <li :style="[activeCategory == category.id ? myTheme.categories.active : '']"
        class="list-group-item category-item"
        v-for="(category, index) in categories"
        :key="index">
        <n-button
          type="primary"
          link
          v-scroll-to="{ el: `#cat_${category.id}`, offset: -180, onStart: onStartScrolling }"
          class="list-group-item list-group-item-action"
          style="color:#000000"
          :id="category.id"
          data-toggle="list"
          >{{ category.name }}</n-button
        >
      </li>
    </ul>
  </affix>
  </div>
</template>
<script>
import { Button, Affix } from "@/components";
export default {
  name:'categories-section',
  components: {
    [Button.name]: Button,
    Affix
  },
  props: {
    categories: Array,
    activeCategory: [String, Number]
  },
  data() {
    return {
      isMounted: false,
      newWidth : "100%"
    };
  },
  methods: {
    onResize(){
      var element = document.getElementById("categorySectionContainer");
      if(element){
        var positionInfos = element.getBoundingClientRect();
        this.newWidth = (positionInfos.width - 30) + "px"
      }
    },
    onStartScrolling(element){
      let elementId = element.getAttribute('id')
      elementId = elementId.split('_');
      this.$emit("setActiveCategory",  elementId.length > 0 ? elementId[1] : elementId[0])
    }
  },
  mounted() {
    
    this.isMounted = true;
    this.onResize();
    this.$nextTick(()=>{
      window.addEventListener("resize", this.onResize);
    })
  },
  beforeDestroy(){
    window.removeEventListener("resize", this.onResize)
  }
};
</script>
<style scoped>
.container-scroller {
  white-space: nowrap;
}

@media screen and (max-width: 768px) {
  .container-scroller.list-group {
    /*flex-direction: row;*/
    overflow-x: auto;
    padding-bottom: 20px;
  }
  .container-scroller .list-group-item.category-item {
    padding: 5px 0 10px;
    margin-right: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
}
</style>
